import { render, staticRenderFns } from "./RoutePath.vue?vue&type=template&id=1c82dda6&"
import script from "./RoutePath.vue?vue&type=script&lang=js&"
export * from "./RoutePath.vue?vue&type=script&lang=js&"
import style0 from "./RoutePath.vue?vue&type=style&index=0&id=1c82dda6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports